import React, {useEffect, useState} from 'react';
import InputRowGroup from "../DataCollection/Inputs/InputRowGroup";
import TextInput from "../DataCollection/Inputs/TextInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import PasswordInput from "../DataCollection/Inputs/PasswordInput";
import {useNavigate} from "react-router-dom";
import {apiRequest} from "../Utils/APIUtils";
import {useAuthenticationStatus} from "./AuthenticationStatusProvider";
import './LoginForm.css';
import ModalPopup from "../ModalPopup/ModalPopup";

const LoginForm = ({setAuthenticated}) => {
    const navigate = useNavigate();
    const {authenticationStatus, setAuthenticationStatus} = useAuthenticationStatus();
    const [alertMessage, setAlertMessage] = useState(''); //This is the message that will be displayed to the user if there is an error

    //TODO: Remove this
    const [loginData, setLoginData] = useState({
        username: '',
        password: '',
    });

    //If the user is currently authenticated, we'll bounce them through to the Dashboard
    useEffect(() => {
        if (authenticationStatus.isAuthenticated) {
            navigate('/');
        }
    }, [authenticationStatus.isAuthenticated]);

    function login() {
        window.location.href = process.env.REACT_APP_ENVIRONMENT_NAME === 'Local Dev' ? 'http://localhost:3001/auth/saml-login' : '/auth/saml-login';
        /*
        apiRequest('auth/login', 'POST', {
                username: loginData.username,
                password: loginData.password,
        }, false)
            .then(response => {

                setAuthenticationStatus({
                    isAuthenticated: response.isAuthenticated,
                    user: response.user,
                });
                if (response.success) {
                    //setAuthenticated(true);
                    navigate('/');
                } else {
                    setAlertMessage('Invalid username or password');
                }
            }).catch(error => {
                setAuthenticationStatus({
                    isAuthenticated: false,
                    user: {},
                });

                if (error.cause && error.cause.status === 500) {
                    setAlertMessage(`Authentication failure - invalid credentials.`);
                } else {
                    setAlertMessage(`Error during authentication process. (${error.message})`);
                }

                console.error('There was a problem with your fetch operation:', error);
            });

         */
    }

    //Don't display the page if the user is already authenticated
    if (authenticationStatus.isAuthenticated === false) {
        return (
            <div className={'login-form'}>

                {alertMessage &&
                    <ModalPopup
                        show={true}
                        onClose={() => setAlertMessage('')}
                    >
                        <div>{alertMessage}</div>
                        <button onClick={() => setAlertMessage('')}>OK</button>
                    </ModalPopup>
                }
                <button onClick={login}>Login with Microsoft 365</button>
                {process.env.NODE_ENV === 'development' &&
                    <div
                        className={'environment-indicator'}>{process.env.REACT_APP_ENVIRONMENT_NAME || process.env.NODE_ENV} </div>
                }
            </div>

        )
    }
}
export default LoginForm;